const store = {
  state: { // 存放当前页面的状态
    navisshow: 'true'
  },
  getters: { // 状态的衍生值，其实就是state中的计算属性
  },
  actions: { // 处理组件中的异步操作
    navChange (context, data) {
      context.commit('changeNavIsShowData', data)
    }
  },
  mutations: { // 唯一改变当前页面的状态的地方
    changeNavIsShowData (state, data) {
      state.navisshow = data // 改变状态管理器中的数据
    }
  }
}

export default store
